// extracted by mini-css-extract-plugin
module.exports = {"header":"MainPage_header__1dTc-","content":"MainPage_content__2ktb_"};